import moment from 'moment';

export const GIFT_IDEAS_ARRAY = [
  { title: 'Esperienze da regalare', url: 'esperienze-da-regalare' },
  { title: 'Esperienze di coppia', url: 'esperienze-di-coppia-da-regalare' },
  { title: 'Compleanno', url: 'regali-compleanno' },
  { title: 'Laurea', url: 'regali-laurea' },
  { title: 'Addio al celibato', url: 'addio-al-celibato' },
  { title: 'Addio al nubilato', url: 'addio-al-nubilato' },
];

export const GIFT_IDEAS_ARRAY_ES = [
  { title: 'Experiencias para regalar', url: 'experiencias-para-regalar' },
  {
    title: 'Experiencias para regalar en pareja',
    url: 'experiencias-para-regalar-en-pareja',
  },
  { title: 'Regalo de cumpleaños', url: 'regalos-cumpleanos' },
  { title: 'Regalo de graduación', url: 'regalos-de-graduacion' },
  { title: 'Despedida de soltero', url: 'despedida-de-soltero' },
  { title: 'Despedida de soltera', url: 'despedida-de-soltera' },
];

const isJanuary = new Date().getMonth() + 1 === 1;
const startYear = moment().year();

export const SEASONAL_GIFT_IDEAS_ARRAY = [
  {
    title: 'Natale',
    url: 'regali-natale',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regali per coppie',
    url: 'regali-natale/per-coppie',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regali per lui',
    url: 'regali-natale/per-lui',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regali per lei',
    url: 'regali-natale/per-lei',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regali per genitori',
    url: 'regali-natale/per-genitori',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regali per famiglie',
    url: 'regali-natale/per-famiglie',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regali Secret Santa',
    url: 'regali-natale/secret-santa',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'San Valentino',
    url: 'regali-san-valentino',
    start: moment(`${startYear}-01-01`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-02-14`, 'YYYY-MM-DD'),
  },
  {
    title: 'Festa del papà',
    url: 'esperienze-da-regalare/festa-del-papa',
    start: moment(`${startYear}-03-01`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-03-19`, 'YYYY-MM-DD'),
  },
  {
    title: 'Festa della mamma',
    url: 'esperienze-da-regalare/festa-della-mamma',
    start: moment(`${startYear}-04-21`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-05-10`, 'YYYY-MM-DD'),
  },
];

export const LESS_IMPORTANT_SEASONAL_GIFT_IDEAS_ARRAY = [
  {
    title: 'San Valentino',
    url: 'regali-san-valentino',
    start: moment(`${startYear}-02-15`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-02-28`, 'YYYY-MM-DD'),
  },
  {
    title: 'Festa del papà',
    url: 'esperienze-da-regalare/festa-del-papa',
    start: moment(`${startYear}-03-20`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-03-27`, 'YYYY-MM-DD'),
  },
  {
    title: 'Festa della mamma',
    url: 'esperienze-da-regalare/festa-della-mamma',
    start: moment(`${startYear}-05-11`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-05-18`, 'YYYY-MM-DD'),
  },
];

export const LESS_IMPORTANT_SEASONAL_GIFT_IDEAS_ARRAY_ES = [
  {
    title: 'Día de la Madre',
    url: 'dia-de-la-madre',
    start: moment(`${startYear}-05-04`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-05-11`, 'YYYY-MM-DD'),
  },
];

export const SEASONAL_GIFT_IDEAS_ARRAY_ES = [
  {
    title: 'Regalos de Navidad',
    url: 'regalos-navidad',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regalos para Hombre',
    url: 'regalos-navidad/hombre',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Regalos para Mujer',
    url: 'regalos-navidad/mujer',
    start: isJanuary
      ? moment(`${startYear - 1}-10-01`, 'YYYY-MM-DD')
      : moment(`${startYear}-10-01`, 'YYYY-MM-DD'),
    end: isJanuary
      ? moment(`${startYear}-01-07`, 'YYYY-MM-DD')
      : moment(`${startYear + 1}-01-07`, 'YYYY-MM-DD'),
  },
  {
    title: 'Día del Padre',
    url: 'dia-del-padre',
    start: moment(`${startYear}-03-01`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-03-27`, 'YYYY-MM-DD'),
  },
  {
    title: 'Día de la Madre',
    url: 'dia-de-la-madre',
    start: moment(`${startYear}-04-21`, 'YYYY-MM-DD'),
    end: moment(`${startYear}-05-03`, 'YYYY-MM-DD'),
  },
];
